export const slideRight = {
  exited: {
    transform: `translateX(100%)`,
  },
  entered: {
    transform: `translateX(0)`,
  },

  animationEntering: `
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
`,
  animationExiting: `
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(100%);
  }`,
};
